// extracted by mini-css-extract-plugin
export default {"container":"RelewiseProductList_container__VXD+G"};